import {memo, useState} from 'react';
import {CountryShort} from "../types/Responses/CountriesResponse";
import {SystemLanguageInterface} from "../types/Responses/SystemResponse";
import {Language} from "../types/Responses/LanguagesResponse";
import CountryAvatar from "./CountryAvatar";
import {Button} from "@material-tailwind/react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";

interface RemovableCountryProps {
    country: CountryShort | SystemLanguageInterface | Language,
    className?: string,
    index: number;
    onCountryRemove: (index: number) => void;
}

const RemovableCountry = ({country, className = '', index, onCountryRemove}: RemovableCountryProps) => {
    const [isHovered, setHovered] = useState<boolean>(false);

    return (
        <div className={`mb-2 flex items-center justify-between ${className ?? ''}`}
             onMouseOver={() => setHovered(true)}
             onMouseLeave={() => setHovered(false)}
        >
            <div>
                <CountryAvatar key={country.name} country={country}
                               className="h-8 max-w-[2rem]"/>
            </div>
            <Button
                className={`text-[0.8rem] shadow-none hover:shadow-none px-1 py-1 text-red-300 bg-transparent border-red-300 ${!isHovered ? 'hidden' : ''}`}
                style={{border: '1px solid'}} onClick={() => onCountryRemove(index)}><FontAwesomeIcon
                icon={solid('trash')} className="w-5"/></Button>
        </div>
    );
}

export default memo(RemovableCountry);
